import * as yup from 'yup';

const duplicateSpecialsValidator = (value: string) => !value.match(/ {2,}|'{2,}|-{2,}/);

export const singleKeywordValidator = yup
  .string()
  .trim()
  .required()
  .min(3, 'Each keyword must be at least 3 characters long')
  .max(15, 'Each keyword must be at most 15 characters long')
  .matches(/^[A-Za-z]+$/, 'Keywords must contain only letters');

export const keywordsValidator = yup
  .array()
  .of(singleKeywordValidator)
  .required("'keywords' is required")
  .min(3, 'At least 3 keywords are required')
  .max(12, 'At most 12 keywords are allowed');

const coloringGridNameValidator = yup
  .string()
  .trim()
  .required('name is required')
  .matches(/^([a-zA-Z0-9 '-]+)$/, 'name must contain only letters, numbers, dashes and apostrophes')
  .test(
    'duplicateSpecials',
    'name cannot contain repeated special characters or spaces',
    duplicateSpecialsValidator,
  )
  .min(3, 'name must be at least 3 characters long')
  .max(60, 'name must be at most 60 characters long');

export const coloringGridDBSchema = yup.object({
  aiGenerated: yup.boolean().required("'aiGenerated' is required"),
  collections: yup.array().of(yup.string().required()).required("'collections' is required"),
  keywords: keywordsValidator,
  name: coloringGridNameValidator,
  status: yup.string(),
  publisher: yup.string(),
  premiumTier: yup
    .number()
    .required("'premiumTier' is required")
    .min(0, "'premiumTier' must be greater or equal to 0"),
  rejectMessage: yup.string().when('status', {
    is: (status: string) => status === 'rejected',
    then: () => yup.string().required('Rejection message is required'),
    otherwise: () => yup.string(),
  }),
});
